import { ComparePage } from "./ComparePage";
import { useLang } from "../lib/i18n";
import { compareGranolaCopy } from "../lib/translations/pages/compare-granola";

export function CompareGranola() {
  const lang = useLang();
  return <ComparePage copy={compareGranolaCopy[lang]} path="/compare/granola-vs-minuta" />;
}
